(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("grapesjs"));
	else if(typeof define === 'function' && define.amd)
		define(["grapesjs"], factory);
	else if(typeof exports === 'object')
		exports["grapesjs-page-break"] = factory(require("grapesjs"));
	else
		root["grapesjs-page-break"] = factory(root["grapesjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 